import React from 'react';
import { connect } from 'react-redux';

import { IRootState } from 'app/shared/reducers';
import { logout } from 'app/shared/reducers/authentication';
import { Translate, translate, Storage } from 'react-jhipster';
import { oauth2 } from 'app/config/constants';

export interface ILogoutProps extends StateProps, DispatchProps {
  idToken: string;
  logoutUrl: string;
}

export class Logout extends React.Component<ILogoutProps> {
  componentWillMount() {
    // this.props.history.push("/");
    // this.props.logout();
  }

  render() {
    var tokenId = Storage.session.get('jhi-authenticationToken');
    Storage.session.remove('jhi-authenticationToken');
    // const logoutUrl = this.props.logoutUrl;
    // if (logoutUrl) {
    //   // if Keycloak, logoutUrl has protocol/openid-connect in it
    //   window.location.href =
    //     logoutUrl.indexOf('/protocol') > -1
    //       ? logoutUrl + '?redirect_uri=' + window.location.origin
    //       : logoutUrl + '?id_token_hint=' + this.props.idToken + '&post_logout_redirect_uri=' + window.location.origin;
    // }
    window.location.href =
      this.props.config.urlAuth +
      '/oidc/logout' +
      '?id_token_hint=' +
      tokenId +
      '&post_logout_redirect_uri=' +
      this.props.config.urlEid +
      '/admin';

    // alert(this.props.config.urlAuth +'/oidc/logout' + '?id_token_hint=' + tokenId + '&post_logout_redirect_uri=' + this.props.config.urlEid + "/admin");
    return <div className="p-5">{/* <h4>Logged out successfully!</h4> */}</div>;
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  logoutUrl: storeState.authentication.logoutUrl,
  idToken: storeState.authentication.idToken,
  config: storeState.applicationProfile.config,
  showModalLogin: storeState.authentication.showModalLogin
});

const mapDispatchToProps = { logout };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Logout);
